/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

const mapping = {
  'local.griffon.adobe.com': 'local',
  'ui-dev.griffon.adobe.com': 'dev',
  'ui-qa.griffon.adobe.com': 'qa',
  'experience-qa.adobe.com': 'qa',
  'ui-stage.griffon.adobe.com': 'stage',
  'experience-stage.adobe.com': 'stage',
  'exc-unifiedcontent.experience-stage.adobe.net': 'stage'
};

export default () => {
  let env = mapping[document.location.hostname] || 'prod';
  if (env !== 'prod') {
    const searchParams = new URLSearchParams(window.location.search);
    env = searchParams.get('pollux') || env;
  }

  return env;
}
